module.exports = __webpack_public_path__ + "static/media/contact.3f8615e1.png";